module.exports = __webpack_public_path__ + "img/service3.741ae888.png";